import ApplicationComponent from "legacy/ApplicationComponent"
import TermsModal from "legacy/TermsModal"
import PropTypes from "prop-types"
import React from "react"

class BoaterTermsModal extends ApplicationComponent {
  render() {
    return (
      <TermsModal
        userId={this.props.userId}
        endpoint={this.props.endpoint}
        showModal={this.props.showModal}
        marinaSide={false}
      >
        <div className="p-2">
          <h2 className="mt-0 text-lg font-bold">Terms of Service update</h2>
          <p>
            At Dockwa, we strive to ensure our policies are clear and
            user-friendly. Starting July 21, 2023, we have updated our Terms of
            Service.
          </p>
          <b>What&apos;s new:</b>
          <p>
            This update includes new language related to the introduction of a
            new payment method - Automated Clearing House (ACH). ACH offers a
            secure and cost-effective way to make payments directly from your
            bank account. We are excited to offer this additional payment option
            as part of our commitment to improve and expand our services.
          </p>

          <b>What you should do:</b>
          <p>
            We encourage you to review the{" "}
            <a
              href="https://ahoy.dockwa.com/about-us/terms-of-service"
              target="_blank"
              rel="noopener noreferrer"
            >
              updated terms
            </a>{" "}
            which will apply to you if you continue to use our products and
            services on and after July 21, 2023.
          </p>
          <p>
            Thank you for being a valued part of the Dockwa Community. Your
            trust in our services is greatly appreciated as we continually work
            to provide you with the best possible experience.
          </p>
        </div>
      </TermsModal>
    )
  }
}

BoaterTermsModal.propTypes = {
  userId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  endpoint: PropTypes.string.isRequired,
  showModal: PropTypes.bool.isRequired,
}

export default BoaterTermsModal
